import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import sweetAlert, {
sweetStatusAlert,
sweetConfirmAlert
} from "../../../../components/common/SweetAlert.js";
import { tableMapService } from "../../../../service/manage/h_tree/table_map.service.js";
import { tableDisplayFieldService } from "../../../../service/manage/h_tree/table_display_field.service.js";
import { tableLogService } from "../../../../service/manage/h_tree/table_log.service.js";
import Spinner from "react-bootstrap/Spinner";
import "../../../../components/admin/css/common.css";
import {
Table,
TableHead,
TableRow,
TableBody,
TableCell
} from "@mui/material";
import MaterialCustomTablePagination from "../../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import SimpleReactValidator from "simple-react-validator";
import PageSpinner from "../../../../components/common/spinner/PageSpinner.js";
import ContentWrapper from "../../../../components/common/ContentWrapper.js";
import config from '../../../../helper/config.js';
import {customerConstants} from "../../../../helper/constants.js";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const getCustomerFeatureFlag = () => {
return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
case customerConstants.EXO_CUSTOMER1:
    break;
case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
    color: "var(--maincolor-cmc)",
    backgroundColor: "#E5F5FF",
    borderColor: "transparent",
    };
    addBtnStyle = {
    color: "#fff",
    backgroundColor: "var(--maincolor-cmc)",
    borderColor: "transparent",
    };
    break;
default:
    break;
}

export default class ManageTableMap extends Component {
constructor(props) {
    super(props);
    this.createValidationsInstance();
    this.state = {
        showModal: false,
        tableMaps: [],
        tableLogs: [],
        table1Columns: [],
        table2Columns: [],
        tb1_id: "",
        tb2_id: "",
        tb1_field: "",
        tb2_field: "",
        table_map_id: "",
        modalType: false,
        search_val: "",
        isLoading: true,
        isSpinnerLoading: false,
        isModified: false,
        limit: 10, // Set the desired limit
        offset: 0, // Set the desired offset
        search_term: "",
        sort_column: "table_map_id",
        sort_direction: "ASC",
        totalTableMaps: 10,
        currentPage: 0,
        editVisibility: true,
        addVisibility: true,
        deleteVisibility: true,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);

    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(this.fetchAllTableMapData, 2000);
}

resetFormFields = () => {
    this.setState({
        tb1_id: "",
        tb2_id: "",
        tb1_field: "",
        tb2_field: "",
    });
};

componentDidMount() {
    this.getAllTableLogs();
    this.fetchAllTableMapData();
}

createValidationsInstance() {
    this.validator = new SimpleReactValidator();
}

getAllTableLogs = async() => {
    this.setState({ isLoading: true });
    await tableLogService.getAllTableLogs()
    .then((response) => {
        if (response.success) {
        this.setState({
            tableLogs: response.data.table_logs
        });
        } else {
        sweetStatusAlert(
            "Failed!",
            "Error fetching Table Logs. Please refresh the screen!",
            "error"
        );
        }
    })
    .catch((error) => {
        sweetStatusAlert(
        "Failed!",
        "Error fetching Table Logs. Please refresh the screen!",
        "error"
        );
    })
    .finally(() => {
        this.setState({ isLoading: false });
    });
}

getTableName(table_id) {
    if (table_id !== null) {
        const table = this.state.tableLogs?.find(
            (table) => table.table_id == parseInt(table_id)
        );
        return table?.table_name;
    }
    else {
        return "N/A";
    }
}

getAllTableColumns = async (table, stateKey = "tableColumns", loadingKey = "isLoading") => {
    this.setState({ [loadingKey]: true });
    try {
        const response = await tableDisplayFieldService.getAllTableColumns(table);
        if (response.success) {
            this.setState({
                [stateKey]: response.data.table_columns
            });
        } else {
            sweetStatusAlert(
                "Failed!",
                "Error fetching Table Columns. Please refresh the screen!",
                "error"
            );
        }
    } catch (error) {
        sweetStatusAlert(
            "Failed!",
            "Error fetching Table Columns. Please refresh the screen!",
            "error"
        );
    } finally {
        this.setState({ [loadingKey]: false });
    }
};

fetchAllTableMapData() {
    const { limit, offset, search_term, sort_column, sort_direction } = this.state;
    tableMapService.getAll(limit, offset, search_term, sort_column, sort_direction)
    .then((response) => {
        if (response.success) {
        this.setState({
            tableMaps: response.data.table_maps,
            totalTableMaps: parseInt(response.data.total_count),
        });
        } else {
        sweetStatusAlert(
            "Failed!",
            "Error fetching table maps. Please refresh the screen!",
            "error"
        );
        }
    })
    .catch((error) => {
        sweetStatusAlert(
        "Failed!",
        "Error fetching table maps. Please refresh the screen!",
        "error"
        );
    })
    .finally(() => {
        this.setState({ isLoading: false, isSpinnerLoading: false });
    });
}

handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
    {
        offset: newOffset,
        isLoading: true,
        currentPage: newPage,
    },
    () => {
        this.fetchAllTableMapData();
    }
    );
};

handleSortChange = (sort_column) => {
    // If the same column is clicked, toggle the sort direction
    const { sort_column: currentSortColumn, sort_direction } = this.state;
    const newSortDirection =
        currentSortColumn === sort_column && sort_direction === "ASC"
        ? "DESC"
        : "ASC";

    this.setState(
        {
            sort_column,
            sort_direction: newSortDirection,
            offset: 0, // Reset offset when changing sorting
            currentPage: 0,
            isLoading: true,
        },
        () => {
            this.fetchAllTableMapData();
        }
    );
};

handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
    {
        offset: newOffset,
        isLoading: true,
        currentPage: newPage
    },
    () => {
        this.fetchAllTableMapData();
    }
    );
};

handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
    {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
    },
    () => {
        this.fetchAllTableMapData();
    }
    );
};

handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
    this.setState(
        {
        search_term,
        isLoading: true,
        offset: 0,
        currentPage: 0,
        searchError: false,
        },
        () => {
            this.debouncedHandleSearch();
        }
    );
    } else {
        this.setState({ search_term, searchError: true });
    }
};

toggleTableMapModal = (modalType) => {
    this.modalType = modalType;
    this.setState((prevState) => ({
        showModal: !prevState.showModal,
    }));
};

toggleUpdateTableMapModal = (tb1_id, tb2_id, tb1_field, tb2_field, table_map_id, modalType) => {
    this.setState((prevState) => ({
        showModal: !prevState.showModal,
        tb1_id: tb1_id,
        tb2_id: tb2_id,
        tb1_field: tb1_field,
        tb2_field: tb2_field,
        table_map_id: table_map_id,
        modalType: modalType,
    }));
};

handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(() => ({ [name]: value, isModified: true }));
};

handleChangeTable1 = async (event) => {
    const selectedTable = event.target.value;

    this.setState({
        tb1_id: selectedTable,
        tb1_field: "",        
        isTable1Loading: true 
    });

    await this.getAllTableColumns(this.getTableName(selectedTable), "table1Columns", "isTable1Loading");
};

handleChangeTable2 = async (event) => {
    const selectedTable = event.target.value;

    this.setState({
        tb2_id: selectedTable,
        tb2_field: "",        
        isTable2Loading: true 
    });

    await this.getAllTableColumns(this.getTableName(selectedTable), "table2Columns", "isTable2Loading");
};

handleChangeTable1Field = (event) => {
    event.preventDefault();
    this.setState({ tb1_field: event.target.value });
};

handleChangeTable2Field = (event) => {
    event.preventDefault();
    this.setState({ tb2_field: event.target.value });
};

handleSweetAlert = (modalType, modalVisibility) => {
    if (this.state.isModified) {
        sweetAlert().then((response) => {
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.modalType = false;
            this.setState(() => ({
            [modalVisibility]: response,
            isModified: false,
            }));
        });
    } else {
        this.validator.hideMessages();
        this.validator.purgeFields();
        this.resetFormFields();
        if (modalType) this.toggleTableMapModal(false);
        else this.toggleUpdateTableMapModal();
    }
};

//Handle Edit Submit
handleEditSubmit = (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.forceUpdate();
    } 
    else 
    {
        this.setState({ isSpinnerLoading: true });
        const tableMapItem = {
            tb1_id: this.state.tb1_id,
            tb2_id: this.state.tb2_id,
            tb1_field: this.state.tb1_field,
            tb2_field: this.state.tb2_field,
        };
        const tableMapId = this.state.table_map_id;

        tableMapService.updateTableMap(tableMapItem, tableMapId)
            .then((response) => {
            if (response.success) {
                this.setState({ isSpinnerLoading: false });
                this.toggleTableMapModal();
                sweetStatusAlert(
                "Success!",
                "Table map information updated successfully!",
                "success"
                );
                this.validator.hideMessages();
                this.validator.purgeFields();
                this.resetFormFields();
                this.fetchAllTableMapData();
            }else {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", response.message, "error");
            }
            })
            .catch((error) => {
            this.setState({ isSpinnerLoading: false });
            sweetStatusAlert(
                "Failed!",
                "Unable to update the table map information",
                "error"
            );
            });
    }
};

//add new Table Map
handleSubmit = (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.forceUpdate();
    } 
    else 
    {
        this.setState({ isSpinnerLoading: true });
        const { tb1_id, tb2_id, tb1_field, tb2_field } = this.state;
        const newTableMapItem = {tb1_id: tb1_id, tb2_id: tb2_id, tb1_field: tb1_field, tb2_field: tb2_field};

        tableMapService.addTableMap(newTableMapItem)
            .then((response) => {
            if (response.success) {
                sweetStatusAlert("Success!", response.message.success, "success");
                this.validator.hideMessages();
                this.validator.purgeFields();
                this.resetFormFields();
                this.toggleTableMapModal(false);
                this.fetchAllTableMapData();
            } else {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", response.message, "error");
            }
            })
            .catch((err) => {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", "Unable to create new table map", "error");
            });
    }
};

handleDeleteTableMap = (id) => {
    sweetConfirmAlert().then(() => {
    this.setState({ isSpinnerLoading: true });
    tableMapService.deleteTableMap(id)
        .then((response) => {
        this.setState({ isSpinnerLoading: false });
        if (response.success) {
            sweetStatusAlert("Success!", response.message.success, "success");
            this.fetchAllTableMapData();
        } else {
            sweetStatusAlert("Failed!", response.message, "error");
        }
        })
        .catch((error) => {
            this.setState({ isSpinnerLoading: false });
            sweetStatusAlert("Oops!", "Error while deleting the table map", "info");
        });
    });
};

render() {
    const {
        limit,
        tableMaps,
        totalTableMaps,
        isLoading,
        currentPage,
        isSpinnerLoading,
        editVisibility,
        addVisibility,
        deleteVisibility,
    } = this.state;
    return (
    <>
        <ContentWrapper>
        <div className="row justify-content-between align-items-center py-5 mb-3">
            <div className="col-md-6 col-6">
            <h3 className="text-nowrap">Manage Table Maps</h3>
            </div>
            <div>
            {addVisibility && (
                <Button
                    className="insert-btn"
                    variant="primary"
                    onClick={() => this.toggleTableMapModal(true)}
                >
                    Add Table Map
                </Button>
            )}
            </div>
        </div>
        <div>
            <Form.Group controlId="exampleForm.ControlInput1" className="mb-2">
            <Form.Control
                type="text"
                placeholder="Search"
                onChange={this.handleSearch}
                isInvalid={this.state.searchError}
                // style={{ width: "18%" }}
                className="col-md-3 col-12"
            />
            {this.state.searchError && (
                <Form.Control.Feedback type="invalid">
                    Invalid input
                </Form.Control.Feedback>
            )}
            </Form.Group>
            {isSpinnerLoading && (
            <PageSpinner id="show" text="Loading, Please wait!" />
            )}
            {isLoading ? (
            <div
                className="loading-container"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "75vw",
                    height: "90vh",
                }}
            >
                <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
                </Spinner>
            </div>
            ) : tableMaps.length > 0 ? (
            <div style={{ width: "75vw", height: "90vh", overflow: "auto" }}>
                <Table>
                <TableHead>
                    <TableRow>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("table_map_id")}
                    >
                        Table Map ID{" "}
                        {this.state.sort_column === "table_map_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("tb1_id")}
                    >
                        Table1 ID{" "}
                        {this.state.sort_column === "tb1_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("tb1_field")}
                    >
                        Table1 Field{" "}
                        {this.state.sort_column === "tb1_field" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("tb2_id")}
                    >
                        Table2 ID{" "}
                        {this.state.sort_column === "tb2_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("tb2_field")}
                    >
                        Table2 Field{" "}
                        {this.state.sort_column === "tb2_field" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    {(editVisibility || deleteVisibility) && (
                        <TableCell className="thead">Actions</TableCell>
                    )}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {tableMaps.map((tableMapItem) => (
                    <TableRow key={tableMapItem.table_map_id}>
                        <TableCell className="tData">
                            {tableMapItem.table_map_id}
                        </TableCell>
                        <TableCell className="tData">
                            {this.getTableName(tableMapItem.tb1_id)}
                        </TableCell>
                        <TableCell className="tData">
                            {tableMapItem.tb1_field}
                        </TableCell>
                        <TableCell className="tData">
                            {this.getTableName(tableMapItem.tb2_id)}
                        </TableCell>
                        <TableCell className="tData">
                            {tableMapItem.tb2_field}
                        </TableCell>
                        {(editVisibility || deleteVisibility) && (
                        <TableCell>
                            <div className="btn-group">
                            {editVisibility && (
                                <Button
                                    onClick={() =>
                                        this.toggleUpdateTableMapModal(
                                            tableMapItem.tb1_id,
                                            tableMapItem.tb2_id,
                                            tableMapItem.tb1_field,
                                            tableMapItem.tb2_field,
                                            tableMapItem.table_map_id,
                                            false
                                        )
                                    }
                                    className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                                    title="Edit Details"
                                />
                            )}
                            {deleteVisibility && (
                                <Button
                                    onClick={() =>
                                        this.handleDeleteTableMap(
                                            tableMapItem.table_map_id
                                        )
                                    }
                                    className="btn btn-icon btn-danger btn-sm m-1 delete-assement-btn flaticon-delete"
                                    title="Delete"
                                />
                            )}
                            </div>
                        </TableCell>
                        )}
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
                <MaterialCustomTablePagination
                    totalCount = {totalTableMaps}
                    currentPage = {currentPage}
                    limit = {limit}
                    handlePageChange = {this.handlePageChange}
                    handleRowsPerPageChange = {this.handleRowsPerPageChange}
                    handlePageOffsetChange = {this.handlePageOffsetChange}
                    offset = {this.state.offset}
                    rowsPerPageOptions={[5, 10, 20]}
                />
            </div>
            ) : (
            <div
                className="text-center mb-5 mt-10"
                style={{ height: "90vh" }}
            >
                <label>No Table Maps Available!</label>
            </div>
            )}
        </div>
        </ContentWrapper>

        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showModal}
            onHide={() => this.handleSweetAlert(this.modalType, "showModal")}
        >
        {this.modalType === true ? (
            <div>
            <Modal.Header closeButton>
                <Modal.Title>Create New Table Map</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Select Table1*</Form.Label>
                    <Form.Select
                            id="tb1_id"
                            value={this.state.tb1_id || ""}
                            onChange={this.handleChangeTable1}
                            className="form-control"
                        >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.tableLogs.map((option, index) => (
                                <option key={index} value={option.table_id}>
                                    {option.table_name}
                                </option>
                            ))}
                    </Form.Select>
                    {this.validator.message(
                        "tb1_id",
                        this.state.tb1_id,
                        "required",
                        {
                        className: "text-danger",
                        }
                    )}
                    </Form.Group>
                    <Form.Group 
                        as={Col} 
                        md="6" 
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Select Table1 Field*</Form.Label>
                    <Form.Select
                        id="tb1_field"
                        value={this.state.tb1_field || ""}
                        onChange={this.handleChangeTable1Field}
                        className="form-control"
                        disabled={this.state.isTable1Loading}
                    >
                        <option value="" disabled hidden style={{ color: "#6c757d" }}>
                            {this.state.isTable1Loading ? "Loading..." : "Nothing Selected"}
                        </option>
                        {!this.state.isTable1Loading && this.state.table1Columns && this.state.table1Columns.map((col, index) => (
                            <option key={index} value={col}>
                                {col}
                            </option>
                        ))}
                    </Form.Select>
                    {this.validator.message(
                        "tb1_field",
                        this.state.tb1_field,
                        "required",
                        { className: "text-danger" }
                    )}
                    </Form.Group>
                </Row>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Select Table2*</Form.Label>
                    <Form.Select
                            id="tb1_id"
                            value={this.state.tb2_id || ""}
                            onChange={this.handleChangeTable2}
                            className="form-control"
                        >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.tableLogs.map((option, index) => (
                                <option key={index} value={option.table_id}>
                                    {option.table_name}
                                </option>
                            ))}
                    </Form.Select>
                    {this.validator.message(
                        "tb2_id",
                        this.state.tb2_id,
                        "required",
                        {
                        className: "text-danger",
                        }
                    )}
                    </Form.Group>
                    <Form.Group 
                        as={Col} 
                        md="6" 
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Select Table2 Field*</Form.Label>
                    <Form.Select
                        id="tb2_field"
                        value={this.state.tb2_field || ""}
                        onChange={this.handleChangeTable2Field}
                        className="form-control"
                        disabled={this.state.isTable2Loading}
                    >
                        <option value="" disabled hidden style={{ color: "#6c757d" }}>
                            {this.state.isTable2Loading ? "Loading..." : "Nothing Selected"}
                        </option>
                        {!this.state.isTable2Loading && this.state.table2Columns && this.state.table2Columns.map((col, index) => (
                            <option key={index} value={col}>
                                {col}
                            </option>
                        ))}
                    </Form.Select>
                    {this.validator.message(
                        "tb2_field",
                        this.state.tb1_field,
                        "required",
                        { className: "text-danger" }
                    )}
                    </Form.Group>
                </Row>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="primary"
                    style={addBtnStyle}
                    onClick={this.handleSubmit}
                >
                    Save changes
                </Button>
                <Button
                    id="modal-close-button"
                    style={closeBtnStyle}
                    onClick={() =>
                        this.handleSweetAlert(this.modalType, "showModal")
                    }
                >
                    Close
                </Button>
            </Modal.Footer>
            </div>
        ) : (
            <div>
            <Modal.Header closeButton>
                <Modal.Title>Update Table Map</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Select Table1*</Form.Label>
                    <Form.Select
                            id="tb1_id"
                            value={this.state.tb1_id || ""}
                            onChange={this.handleChangeTable1}
                            className="form-control"
                        >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.tableLogs.map((option, index) => (
                                <option key={index} value={option.table_id}>
                                    {option.table_name}
                                </option>
                            ))}
                    </Form.Select>
                    {this.validator.message(
                        "tb1_id",
                        this.state.tb1_id,
                        "required",
                        {
                        className: "text-danger",
                        }
                    )}
                    </Form.Group>
                    <Form.Group 
                        as={Col} 
                        md="6" 
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Select Table1 Field*</Form.Label>
                    <Form.Select
                        id="tb1_field"
                        value={this.state.tb1_field || ""}
                        onChange={this.handleChangeTable1Field}
                        className="form-control"
                        disabled={this.state.isTable1Loading}
                    >
                        <option value="" disabled hidden style={{ color: "#6c757d" }}>
                            {this.state.isTable1Loading ? "Loading..." : "Nothing Selected"}
                        </option>
                        {!this.state.isTable1Loading && this.state.table1Columns && this.state.table1Columns.map((col, index) => (
                            <option key={index} value={col}>
                                {col}
                            </option>
                        ))}
                    </Form.Select>
                    {this.validator.message(
                        "tb1_field",
                        this.state.tb1_field,
                        "required",
                        { className: "text-danger" }
                    )}
                    </Form.Group>
                </Row>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Select Table2*</Form.Label>
                    <Form.Select
                            id="tb1_id"
                            value={this.state.tb2_id || ""}
                            onChange={this.handleChangeTable2}
                            className="form-control"
                        >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.tableLogs.map((option, index) => (
                                <option key={index} value={option.table_id}>
                                    {option.table_name}
                                </option>
                            ))}
                    </Form.Select>
                    {this.validator.message(
                        "tb2_id",
                        this.state.tb2_id,
                        "required",
                        {
                        className: "text-danger",
                        }
                    )}
                    </Form.Group>
                    <Form.Group 
                        as={Col} 
                        md="6" 
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Select Table2 Field*</Form.Label>
                    <Form.Select
                        id="tb2_field"
                        value={this.state.tb2_field || ""}
                        onChange={this.handleChangeTable2Field}
                        className="form-control"
                        disabled={this.state.isTable2Loading}
                    >
                        <option value="" disabled hidden style={{ color: "#6c757d" }}>
                            {this.state.isTable2Loading ? "Loading..." : "Nothing Selected"}
                        </option>
                        {!this.state.isTable2Loading && this.state.table2Columns && this.state.table2Columns.map((col, index) => (
                            <option key={index} value={col}>
                                {col}
                            </option>
                        ))}
                    </Form.Select>
                    {this.validator.message(
                        "tb2_field",
                        this.state.tb1_field,
                        "required",
                        { className: "text-danger" }
                    )}
                    </Form.Group>
                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="modal-btn"
                    variant="primary"
                    style={addBtnStyle}
                    onClick={this.handleEditSubmit}
                >
                    Save changes
                </Button>
                <Button
                    className="modal-btn"
                    id="modal-close-button"
                    style={closeBtnStyle}
                    onClick={() =>
                        this.handleSweetAlert(this.modalType, "showModal")
                    }
                >
                    Close
                </Button>
            </Modal.Footer>
            </div>
        )}
        </Modal>
    </>
    );
}
}
